module.exports = __webpack_public_path__ + "static/img/2.8f075c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eg/2.png
// module id = 122
// module chunks = 2